<template>
  <div class="regist-container" id="regist-container">
    <div class="logo" style="margin-bottom: 10px">
      <img src="../assets/images/logo.png"/>
    </div>
    <div
      class="registArea"
      v-show="currentStep===1"
    >
      <div>
        <el-form
          ref="registStepOne"
          :rules='rules'
          :model='registFormOneData'
        >
          <div class="formArea">
            <el-form-item
              label=''
              prop='name'
            >
              <el-input
                class="regist-input"
                prefix-icon="el-icon-s-shop"
                v-model="registFormOneData.name"
                placeholder='请输入店铺名称'
                autocomplete="on"
              ></el-input>
            </el-form-item>
            <el-form-item
              label=''
              prop='loginName'
            >
              <el-input
                class="regist-input"
                type="number"
                prefix-icon="el-icon-phone"
                :maxlength="11"
                v-model="registFormOneData.loginName"
                placeholder='请输入手机号'
                @input="changeNumber"
              ></el-input>
            </el-form-item>
            <el-form-item
              label=''
              prop='validateCode'
            >
              <div class="velidateArea">
                <el-input
                  class="regist-input"
                  type="number"
                  prefix-icon="el-icon-lollipop"
                  v-model="registFormOneData.validateCode"
                  @change="checkVerCode"
                  placeholder='请输入验证码'
                ></el-input>
                <div
                  :class="isHasPhone ? 'velidateCode' : 'disabled'"
                  @click="sendVerCode"
                  v-if="!isDisabled"
                >验证码</div>
                <div
                  class="disabled"
                  v-else
                >{{ count }}秒
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label=''
              prop='password'
            >
              <el-input
                class="regist-input"
                type='password'
                prefix-icon="el-icon-lock"
                v-model="registFormOneData.password"
                placeholder='请输入密码'
              ></el-input>
            </el-form-item>
            <el-form-item
              label=''
              prop='repassword'
            >
              <el-input
                class="regist-input"
                prefix-icon="el-icon-lock"
                type='password'
                v-model="registFormOneData.repassword"
                placeholder='请再次输入密码'
              ></el-input>
            </el-form-item>
            <el-form-item
              label=''
              prop=''
            >
              <el-input
                class="regist-input"
                prefix-icon="el-icon-magic-stick"
                v-model="registFormOneData.inviteCode"
                placeholder='请输入邀请码(非必填)'
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="nextStep">
                <el-button
                  type='primary'
                  @click="submit"
                >提交注册</el-button>
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label=''
            prop='agreement'
          >
            <div
              class=""
              style="margin-top:10px"
            >
              <el-checkbox v-model="agreement">同意并接受</el-checkbox>
              <router-link
                to="/userAgreement"
                target="_blank"
              >
                <span style="color:#458cff;cursor:pointer">《用户协议》</span>
              </router-link>
              <router-link
                to="/privacyPolicy"
                target="_blank"
              ><span class="login-txt">《隐私策略》</span></router-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      v-show="currentStep===2"
      class="registArea"
    >
      <div class="successArea">
        <div class="circle"><i class="el-icon-check"></i></div>
        <div class="login-txt" style="color:#fff">注册成功</div>
      </div>
      <div class="login-txt" @click="reback" style="font-size: 12px;margin-top:50px;text-decoration:underline">返回注册</div>
    </div>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.9)"
    >
    </div>
    <div
      v-show="currentStep===3"
      class="registArea"
    >
      <div class="successArea">
        <div class="circleX"><i class="el-icon-close"></i></div>
        <div class="login-txt" style="color:#fff">注册失败</div>
      </div>
      <div class="login-txt" @click="reback" style="font-size: 12px;margin-top:50px;text-decoration:underline">返回注册</div>
    </div>
  </div>
</template>
<script>
import api from "@/config/api.js";
export default {
  data(){
    let checkLoginName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    let checkPass = (rule, value, callback) => {
      this.$refs.registStepOne.validateField("repassword");
      callback();
    };
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请再次输入密码"));
      } else if (value !== this.registFormOneData.password) {
        return callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    let checkAgreement = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请先阅读协议"));
      } else {
        callback();
      }
    };
    return{
      isTrueCode:false,
      isHasPhone:false,
      loading: false,
      content: "短信验证码",
      isDisabled: false, // 短信发送按钮
      count: 60,
      addressProp: "province", //地址循环校验
      agreement: false,
      tipError: false, //拼图相关字段
      puzzleShow: false,
      diff: 0, //拼图拖动距离
      registFormOneData: {
        name:'',
        loginName: "",
        password: "",
        repassword: "",
        validateCode: "",
        agreement: false,
        inviteCode:'',
      },
      rules: {
        loginName: [{ validator: checkLoginName, trigger: "blur" }],
        password: [{ validator: checkPass, trigger: "blur" }],
        repassword: [{ validator: checkPassword, trigger: "blur" }],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        agreement: [{ validator: checkAgreement }],
        name: [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
      },
      currentStep: 1,
      options: [],
      value: "",
    }
  },
  watch: {
    agreement: {
      handler(val, old) {
        this.registFormOneData.agreement = val;
      },
    },
  },
  mounted() {
    this.getClientHeight()
    let currentUrl = window.location.href; //获取当前链接
    // var currentUrl = 'http://322n599v37.qicp.vip?inviteCode=88223123'
    if(currentUrl.indexOf('?')!=-1&&currentUrl.indexOf('inviteCode')!=-1){
      let strCode = currentUrl.split("?")[1]
      this.registFormOneData.inviteCode = strCode.split("=")[1]
    }else{
      this.registFormOneData.inviteCode = ''
    }
  },
  methods:{
    // 返回注册
    reback(){
      this.currentStep=1
      this.registFormOneData={
        name:'',
        loginName: "",
          password: "",
          repassword: "",
          validateCode: "",
          agreement: false,
      }
    },
    // 获取设备高度
    getClientHeight(){
      let orderHight = document.body.clientHeight
      let orderWidth = document.body.clientWidth
      document.getElementById('regist-container').style.height = orderHight + 'px'
      document.getElementById('regist-container').style.width = orderWidth + 'px'
    },
    // 输入手机号
    changeNumber(val){
      if(val.length==11){
        this.inputPhoneNumber()
      }else{
        this.isHasPhone = false
      }
    },
    // 验证手机号码是否注册
    inputPhoneNumber() {
      return new Promise((reslove,reject)=>{
        if (this.registFormOneData.loginName && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.registFormOneData.loginName)) {
          this.$axios.fetchGet(api.sysUserVerifyPhone + '?phone=' + this.registFormOneData.loginName, {}).then((res) => {
            if (res.code == 200) {
              if (res.data) {
                console.log(res.data)
                this.isHasPhone = true;
              } else {
                this.isHasPhone = false;
                this.$message({
                  message: "该号码已注册",
                  type: "warning",
                });
              }
              reslove(this.isHasPhone)
            } else {
              reject(res.errorMsg)
            }
          })
        }
      })
    },
    // 倒计时
    timer() {
      if (this.count == 0) {
        this.isDisabled = false;
        this.count = 0;
      } else {
        this.isDisabled = true;
        this.count--;
        setTimeout(() => {
          this.timer();
        }, 1000);
      }
    },
    // 获取验证码
    sendVerCode() {
      this.inputPhoneNumber().then(()=>{
        if(this.isHasPhone){
          let url =api.getPhoneCode + '?phone=' + this.registFormOneData.loginName;
          this.$axios.fetchPost(url, {}).then((res) => {
            if (res.code === 200) {
              this.$nextTick(() => {
                this.count = 60;
                this.timer();
              })
            } else {
              this.$message.error("短信发送失败:" + res.errorMsg);
            }
          });
        }
      })
    },
    // 校验验证码是否正确
    checkVerCode(code) {
      if (
        !this.registFormOneData.loginName ||
        this.registFormOneData.loginName === ""
      ) {
        return;
      }
      let url =
        "/api/eros/se/seMerchant/check/verCode?phone=" +
        this.registFormOneData.loginName +
        "&validateCode=" +
        code;
      this.$axios
        .fetchPost(url, {})
        .then((res) => {
          if (res.code === 200) {
            if (!res.data) {
              this.registFormOneData.validateCode = "";
              this.$message({
                message: "请输入正确验证码",
                type: "error",
              });
              this.isTrueCode = false
            }else{
              this.isTrueCode = true
            }
          } else {
            this.$message.error("发送异常");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交
    submit() {
      this.$refs.registStepOne.validate((valid) => {
        if (valid && this.isTrueCode) {
          this.loading = true;
          let url = "/api/eros/se/seMerchant/register";
          this.$axios
            .fetchPost(url, this.registFormOneData)
            .then((res) => {
              if (res.code === 200) {
                this.currentStep = 2;
              } else {
                this.currentStep = 3;
                this.$message.error('注册失败')
              }
              this.loading = false;
            })
            .catch((err) => {
              this.$message.error(err.errorMsg);
            });
        }else{
          return false;
        }
      });
    },
  }
}
</script>
<style scoped>
.regist-container{
  overflow: hidden;
  background: url("../assets/images/regist.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-flow: column nowrap;
  /*justify-content: center;*/
  align-items: center;
  position: relative;
  padding-top:20%;
}
.regist-container .login-txt {
  color: #458cff;
  cursor: pointer;
}
.regist-container .registArea {
  width:80%;
  /*background-color:  rgba(0, 0, 0, 0.3);*/
  border-radius: 4px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
}
.regist-container .regist-input{
  width:100%;
  border-radius: 30px;
  font-size: 20px;
}
.regist-container .regist-input >>> .el-input__inner{
  height:50px;
  border-radius: 30px;
  border-color: #666;
  background-color: rgba(0, 0, 0,0.9);
  color:#fff;
  font-size: 14px;
}
.regist-container >>> .el-form-item{
  height:70px;
  padding:10px 0;
}
.regist-container >>> .el-form-item__error{
  padding-left:10px;
}
.regist-container >>> .el-button--primary{
  width:100% !important;
  height:50px;
  line-height: 50px;
  border-radius: 30px;
  outline: none;
  font-size: 16px;
}
.regist-container .registArea .successArea {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30%;
}
.regist-container .registArea .login-txt {
  text-align: center;
  color: #458cff;
  cursor: pointer;
}
.regist-container .registArea .successArea .circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #458cff;
  background-color: #458cff;
  margin: 20px 0;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #fff;
}
.regist-container .registArea .successArea .circleX{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid red;
  background-color: red;
  margin: 20px 0;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #fff;
}

.regist-container .registArea .formArea .velidateArea {
  display: flex;
  justify-content: space-between;
}
.regist-container .disabled {
  border-radius: 30px;
  display: inline-block;
  height:50px;
  line-height: 50px;
  width: 150px;
  vertical-align: bottom;
  text-align: center;
  background-color: rgba(0, 0, 0,0.7);
  margin-left: 10px;
  border:1px solid #666;
  cursor: unset;
  color:#ccc;
}
.regist-container .velidateCode {
  border-radius: 30px;
  display: inline-block;
  height:50px;
  line-height: 50px;
  width: 150px;
  margin-left: 10px;
  vertical-align: bottom;
  text-align: center;
  background-color: #458CFF;
  cursor: pointer;
  color:#fff;
}

/*改变placeholder颜色*/
.regist-container >>> ::-webkit-input-placeholder{
  color: #666;
  -webkit-text-fill-color: #666;
}
/*在移动端a、input、label等标签点击后会出现背景阴影问题*/
a,input,button,label{-webkit-tap-highlight-color:transparent;}
</style>



// WEBPACK FOOTER //
// src/page/RegistApp.vue